import type { CreateStockInRequest } from "@stocks/shared";

export type VendorMode = "existing" | "new";
export type LotMode = "new" | "existing";
export type LocationMode = "existing" | "new" | "none";

/** 입고 입력 폼 값 (input 은 문자열로 다룬다) */
export interface StockInFormValues {
  vendorMode: VendorMode;
  vendorId: string;
  newVendorCode: string;
  newVendorName: string;
  receivedAt: string;
  quantity: string;
  lotMode: LotMode;
  lotId: string;
  supplierLotNo: string;
  expiresAt: string;
  locationMode: LocationMode;
  locationId: string;
  newLocationCode: string;
  newLocationName: string;
  memo: string;
}

const pad = (n: number) => String(n).padStart(2, "0");

/** 로컬 기준 오늘 (YYYY-MM-DD) */
export const todayString = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const emptyStockInForm = (): StockInFormValues => ({
  vendorMode: "existing",
  vendorId: "",
  newVendorCode: "",
  newVendorName: "",
  receivedAt: todayString(),
  quantity: "",
  lotMode: "new",
  lotId: "",
  supplierLotNo: "",
  expiresAt: "",
  locationMode: "existing",
  locationId: "",
  newLocationCode: "",
  newLocationName: "",
  memo: "",
});

/** 오늘이면 현재 시각, 과거 날짜는 해당 일 로컬 0시를 ISO 로 보낸다. */
const toReceivedAt = (date: string) =>
  date === todayString()
    ? new Date().toISOString()
    : new Date(`${date}T00:00:00`).toISOString();

export const toCreateStockInRequest = (
  values: StockInFormValues,
  ids: { itemId: string; vendorId: string; requestId: string },
): CreateStockInRequest => ({
  itemId: ids.itemId,
  vendorId: ids.vendorId,
  quantity: Number(values.quantity),
  receivedAt: toReceivedAt(values.receivedAt),
  ...(values.lotMode === "existing"
    ? { lotId: values.lotId }
    : {
        newLot: {
          supplierLotNo: values.supplierLotNo.trim() || undefined,
          expiresAt: values.expiresAt
            ? new Date(`${values.expiresAt}T00:00:00`).toISOString()
            : undefined,
        },
      }),
  ...(values.locationMode === "existing" && values.locationId
    ? { locationId: values.locationId }
    : {}),
  ...(values.locationMode === "new"
    ? {
        newLocation: {
          code: values.newLocationCode.trim(),
          name: values.newLocationName.trim(),
        },
      }
    : {}),
  memo: values.memo.trim() || undefined,
  requestId: ids.requestId,
});
